module.exports = __webpack_public_path__ + "img/couples-030.d4a98966.jpg";